import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { CloseIcon } from '@svgs'
import { clearCompare } from 'src/redux/slices/propertySearchSlice'
import { RootState } from 'src/redux/store'
import CompareModal from './CompareModal'

// Floating action bar: appears once at least two listings are picked for
// comparison anywhere in the app (the cards' compare toggle).
const CompareBar: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const compareIds = useSelector((state: RootState) => state.propertySearch.compareIds)
  const [open, setOpen] = useState(false)

  if (compareIds.length < 2) return null

  return (
    <>
      {/* z-50 so it clears the announcement's floating share/CTA (z-40) —
          the bar was hidden behind it (owner feedback B6). Phones: over the
          menu, or over the home indicator where there is no menu (a guest). */}
      <div className="fixed bottom-[calc(var(--bottom-bar-h)+1.25rem)] md:bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2 bg-inverse text-white rounded-full shadow-lg">
        <button className="font-bold text-sm" onClick={() => setOpen(true)}>
          {t('compare.open', { count: compareIds.length })}
        </button>
        <button
          type="button"
          aria-label={t('compare.clear')}
          // white at 70% on the dark bar (8:1); the ink at 30% it had read at
          // 1.3:1, the cross was all but invisible
          className="inline-flex items-center justify-center w-8 h-8 -mr-2 rounded-full text-sm text-white/70 hover:text-white hover:bg-white/10"
          onClick={() => dispatch(clearCompare())}
        >
          <span className="icon-button w-3 h-3 fill-current">
            <CloseIcon />
          </span>
        </button>
      </div>
      <CompareModal open={open} handleClose={() => setOpen(false)} ids={compareIds} />
    </>
  )
}

export default CompareBar
